<template>
  <div class="shuiyin"></div>
</template>

<script>
export default {};
</script>

<style scoped>
.shuiyin {
  width: 100%;
  height: 100%;
  background-image: url("../images/suiying.png");
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  opacity: 0.2;
}
</style>